/**
 * 페이지 이동 시 경로 검증을 위한 유틸리티 함수들
 */

/**
 * 경로가 유효한지 검증하는 함수
 * @param {string|undefined|null} path - 검증할 경로
 * @returns {boolean} 유효한 경로인지 여부
 */
export const isValidPath = (path) => {
  return path !== null && path !== undefined && path !== '';
};

/**
 * 안전한 window.open 함수
 * 경로가 유효하지 않으면 페이지를 열지 않음
 * @param {string|undefined|null} url - 열려는 URL
 * @param {string} target - 타겟 윈도우 (_blank, _self 등)
 * @param {string} features - 윈도우 특성
 * @returns {Window|null} 열린 윈도우 객체 또는 null
 */
export const safeWindowOpen = (url, target = '_blank', features = '') => {
  if (!isValidPath(url)) {
    console.warn('페이지 이동이 취소되었습니다: 유효하지 않은 경로입니다.', { url });
    return null;
  }
  return window.open(url, target, features);
};

/**
 * 안전한 history.push 함수
 * 경로가 유효하지 않으면 페이지를 이동하지 않음
 * @param {object} history - React Router history 객체
 * @param {string|object|undefined|null} path - 이동할 경로 또는 location 객체
 * @returns {boolean} 이동 성공 여부
 */
export const safeHistoryPush = (history, path) => {
  if (!history) {
    console.warn('페이지 이동이 취소되었습니다: history 객체가 없습니다.');
    return false;
  }

  // path가 객체인 경우 pathname을 검증
  const pathToValidate = typeof path === 'object' && path !== null ? path.pathname : path;

  if (!isValidPath(pathToValidate)) {
    console.warn('페이지 이동이 취소되었습니다: 유효하지 않은 경로입니다.', { path });
    return false;
  }

  history.push(path);
  return true;
};

/**
 * 안전한 history.replace 함수
 * 경로가 유효하지 않으면 페이지를 이동하지 않음
 * @param {object} history - React Router history 객체
 * @param {string|object|undefined|null} path - 이동할 경로 또는 location 객체
 * @returns {boolean} 이동 성공 여부
 */
export const safeHistoryReplace = (history, path) => {
  if (!history) {
    console.warn('페이지 이동이 취소되었습니다: history 객체가 없습니다.');
    return false;
  }

  // path가 객체인 경우 pathname을 검증
  const pathToValidate = typeof path === 'object' && path !== null ? path.pathname : path;

  if (!isValidPath(pathToValidate)) {
    console.warn('페이지 이동이 취소되었습니다: 유효하지 않은 경로입니다.', { path });
    return false;
  }

  history.replace(path);
  return true;
};

/**
 * 안전한 window.location.href 설정 함수
 * 경로가 유효하지 않으면 페이지를 이동하지 않음
 * @param {string|undefined|null} url - 이동할 URL
 * @returns {boolean} 이동 성공 여부
 */
export const safeLocationHref = (url) => {
  if (!isValidPath(url)) {
    console.warn('페이지 이동이 취소되었습니다: 유효하지 않은 경로입니다.', { url });
    return false;
  }

  window.location.href = url;
  return true;
};
